import React from 'react';
import { Icon } from 'ui';
import Table from 'components/shared/table';

const ArchivesTitleCell = ({ urls, title, id }) => (
  <Table.BodyCell size="xl" name="title" split>
    <div className="text-wrap">
      <a href={urls.overview}>{title}</a>
    </div>
    <div className="IndexAction-container">
      {!!urls.preview && (
        <a
          className="IndexAction-button ButtonWithTooltip IndexAction-button--square"
          target={`lesson_preview_${id}`}
          data-tooltip="Preview"
          href={urls.preview}
        >
          <Icon name="preview" />
        </a>
      )}
      {!!urls.copy && (
        <a
          className="IndexAction-button
          ButtonWithTooltip IndexAction-button--square"
          data-tooltip="Copy"
          data-method="post"
          data-remote="true"
          href={urls.copy}
        >
          <Icon name="copy" />
        </a>
      )}
    </div>
  </Table.BodyCell>
);

export default ArchivesTitleCell;
